import React, { useContext } from "react";

import { Button } from "@mui/material";
import InputSelectionComponent from "../Dashboard/Component/inputSelection";
import { AuthContext } from "../../context/auth-context";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import RadioButtonsGroup from "../../Component/UI/RadioGroup/RadioGroup";
import { ENTITY_LABELS } from "../../utils/labelMapping";



const EAB_SITE_SUGGESTIONS = [
  { id: 10, name: "Collegevine", value: "collegevine.com" },
  { id: 11, name: "Niche", value: "niche.com" },
  { id: 12, name: "College Confidential", value: "collegeconfidential.com" },
];

const SITE_SUGGESTIONS = [
  { id: 1, name: "Reddit", value: "reddit.com" },
  { id: 2, name: "Facebook", value: "facebook.com" },
  { id: 3, name: "Quora", value: "quora.com" },
  { id: 4, name: "X", value: "x.com" },
  { id: 5, name: "LinkedIn", value: "linkedin.com" },
  { id: 6, name: "YouTube", value: "youtube.com" },
  { id: 7, name: "Trust Pilot", value: "trustpilot.com" },
  { id: 8, name: "Glassdoor", value: "glassdoor.com" },
  { id: 9, name: "Wikipedia", value: "wikipedia.org" },
];

const QUERY_TYPE_OPTIONS = [
  { id: 1, name: 'Brand', value: 'brand' },
  { id: 2, name: 'Category', value: 'category' },
];

const DashboardNav = ({
  selectedOptionShow,
  contentTypes,
  brandItems,
  selectedBrandItems,
  handleBrandCheckChange,
  handleProductCheckChange,
  selectedProductItems,
  productItems,
  isFirstTime,
  selectedPersona,
  handlePersonaCheckChange,
  personas,
  selectedGeographyItems,
  handleGeographyCheckChange,
  geography,
  selectedMarketItems,
  handleMarketCheckChange,
  markets,
  selectedLlmItems,
  handleLlmCheckChange,
  dbLlms,
  showData,
  isDone,
  handleClickShow,
  filterModalType,
  showNav = true,
  setSelectedOptionShow,
  categories,
  handleCategoryCheckChange,
  selectedCategory,
  selectedSiteSuggestions,
  handleSiteSuggestionsCheckChange,
  excludeBrandOwnedSources,
  handleExcludeBrandOwnedSourcesChange,
  isLoading,
  onCancel,
  selectedQueryTypes,
  onQueryTypesChange,
  isDemoMode = false,
  noMonitoringData = false,
  siteSuggestionOptions,
}) => {
  const authCtx = useContext(AuthContext);
  const siteSuggestions = Array.isArray(siteSuggestionOptions)
    ? siteSuggestionOptions
    : authCtx?.user?.customer?.name === "EAB"
      ? [...SITE_SUGGESTIONS, ...EAB_SITE_SUGGESTIONS]
      : SITE_SUGGESTIONS;

  const RADIO_OPTIONS = [
  {
    value: "Company/Brand",
    label: ENTITY_LABELS.brand,
  },
  {
    value: "Product",
    label: ENTITY_LABELS.product,
  },
];
  const handleTypeChange = (value) => {
    if (setSelectedOptionShow) {
      setSelectedOptionShow(value);
    }
  };
  return (
    <>
      <div>
        <RadioButtonsGroup
          options={RADIO_OPTIONS}
          selectedvalue={selectedOptionShow}
          onChange={handleTypeChange}
        />
      </div>

      <div className="customTabContent tab-content" id="nav-tabContent">
        <div
          className="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="nav-competition-tab"
        >
          <div className="row">
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-briefcase"></i>
                </span>
                {selectedOptionShow === "Company/Brand" ? (
                  <InputSelectionComponent
                    options={brandItems}
                    selectedOptions={selectedBrandItems}
                    handleChange={handleBrandCheckChange}
                  // type="brand"
                  />
                ) : (
                  <InputSelectionComponent
                    options={productItems}
                    selectedOptions={selectedProductItems}
                    handleChange={handleProductCheckChange}
                  // type="product"
                  />
                )}
              </div>
            </div>

            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-user"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedCategory}
                  handleChange={handleCategoryCheckChange}
                  options={categories}
                // type="category"
                />
              </div>
            </div>
            <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-user"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedPersona}
                  handleChange={handlePersonaCheckChange}
                  options={personas}
                // type="persona"
                />
              </div>
            </div>

            {/* <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-map-pin"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedGeographyItems}
                  handleChange={handleGeographyCheckChange}
                  options={geography}
                  type="geography"
                />
              </div>
            </div> */}

                     <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-globe"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedSiteSuggestions || []}
                  handleChange={handleSiteSuggestionsCheckChange}
                  options={siteSuggestions}
                  type="site"
                />
              </div>
            </div>
            
          </div>
          <div className="row mt-1 align-items-center">

            {/* <div className="col-md-2 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-map-pin"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedMarketItems}
                  handleChange={handleMarketCheckChange}
                  options={markets}
                  type="market"
                />
              </div>
            </div> */}

            {/* <div className="col-md-3 position-relative">
              <div className="input-group input-group-lg mb-3">
                <span className="input-group-text" id="basic-addon1">
                  <i className="feather icon-globe"></i>
                </span>

                <InputSelectionComponent
                  selectedOptions={selectedSiteSuggestions || []}
                  handleChange={handleSiteSuggestionsCheckChange}
                  options={siteSuggestions}
                  type="site"
                />
              </div>
            </div> */}

            <div className="col-md-2 position-relative">
              <div className="input-group input-group-lg mb-3">
                <InputSelectionComponent
                  selectedOptions={selectedQueryTypes || []}
                  handleChange={onQueryTypesChange}
                  options={QUERY_TYPE_OPTIONS}
                  type="queryType"
                />
              </div>
            </div>

            <div className="col-md-3 d-flex align-items-center mb-3">
              <div className="form-check d-flex align-items-center" style={{ gap: '6px' }}>
                <input
                  className="form-check-input mt-0"
                  type="checkbox"
                  id="eliminateBrandContent"
                  checked={excludeBrandOwnedSources}
                  onChange={handleExcludeBrandOwnedSourcesChange}
                />
                <label className="form-check-label" htmlFor="eliminateBrandContent" style={{ marginBottom: 0, cursor: 'pointer' }}>
                  Eliminate brand content/posts
                </label>
              </div>
            </div>

            <div className="col-md-2 d-flex align-items-center mb-3">
              <Button
                disabled={!isDone || isDemoMode || noMonitoringData}
                style={{
                  backgroundColor: "gainsboro",
                  borderColor: "gainsboro",
                  color: "black",
                }}
                variant="contained"
                color={"secondary"}
                onClick={handleClickShow}
              >
                Generate
              </Button>
              {isLoading && (
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#f44336",
                    borderColor: "#f44336",
                    color: "white",
                  }}
                  onClick={onCancel}
                >
                  Cancel
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardNav;
